import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createFieldOption, updateFieldOption, deleteFieldOption } from '../../api/CHAMPS/champs';

export const useCreateFieldOption = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, optionData }) => createFieldOption(id, optionData),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champ', variables.id] });
    },
  });
};

export const useUpdateFieldOption = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ customFieldId, optionId, optionData }) => updateFieldOption(customFieldId, optionId, optionData),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champ', variables.customFieldId] });
    },
  });
};

export const useDeleteFieldOption = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ customFieldId, optionId }) => deleteFieldOption(customFieldId, optionId),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['champ', variables.customFieldId] });
    },
  });
};
